import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

const pinia = createPinia();

// Vuetify
import { createVuetify } from "vuetify";
import "vuetify/styles";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "./assets/custom-theme.scss";

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);

app.provide("defaultBookURL", "/book/suttapitaka/dighanikaya/silakkhandhavaggapali_dn_i/01_brahmajalasutta/1");

app.use(vuetify).use(pinia).use(router).mount("#app");
